export default __webpack_public_path__ + "static/media/machine-ic.84397e91.svg";